import React from 'react'

const TablaCodDxCompDQ = ({item}) => {
  
  return (
    <tr key={item.ConsCod} className="border-b" >
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.DxCompl}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.DMNomb}
      </td>
    </tr>
  )
}

export default TablaCodDxCompDQ